export const PRODUCTION_NAV_PREFIX = 'https://tools.picsart.com';
export const PREPROD_NAV_PREFIX = 'https://tools-preprod.picsart.com';

export function getNavLink(path: string, withoutTrailingSlash = false) {
  return withoutTrailingSlash ? path : `${path}/`;
}
